import { render, staticRenderFns } from "./EstimateNote.vue?vue&type=template&id=645b29e5&scoped=true&"
import script from "./EstimateNote.vue?vue&type=script&lang=js&"
export * from "./EstimateNote.vue?vue&type=script&lang=js&"
import style0 from "./EstimateNote.vue?vue&type=style&index=0&id=645b29e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b29e5",
  null
  
)

export default component.exports